import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { changePasswordAction, signIn } from '../actions/auth';
import { passwordInfoMessage } from '../constants/text';
import Validator from './common/forms/Validator';
import ErrorMessage from './common/forms/ErrorMessage';
import BackArrow from './common/ui/BackArrow';
import ContentWrapper from './common/ContentWrapper';

class ChangePassword extends Validator {
  static propTypes = {
    changePasswordAction: PropTypes.func.isRequired,
    signIn: PropTypes.func.isRequired
  };

  state = {
    oldPassword: '',
    newPassword: ''
  };

  validationRules = {
    oldPassword: { required: true },
    newPassword: { required: true }
  };

  handleChange = event => {
    const { name, value } = event.target;
    this.setState({
      [name]: value
    });
  };

  submitChangePassword = event => {
    event.preventDefault();

    if (this.validate(this.validationRules)) {
      const { oldPassword, newPassword } = this.state;
      const { changePasswordAction, signIn, history } = this.props;
      const formData = {
        oldPassword,
        newPassword,
        newPasswordConfirm: newPassword
      };
      changePasswordAction(formData).then(userData => {
        if (userData) {
          signIn(userData.email, newPassword).then(data => {
            if (data) {
              history.goBack();
            }
          });
        }
      });
    }
  };

  render () {
    const { oldPassword, newPassword } = this.state;
    return (
      <ContentWrapper full>
        <div className='auth-form-wrapper'>
          <div className='d-flex align-center mb-3'>
            <BackArrow
              history={this.props.history}
              location={this.props.location}
            />
            <h1 className='w-100'>Change Password</h1>
          </div>
          <form className='form-group' onSubmit={this.submitChangePassword}>
            <div className='form-group'>
              <label htmlFor='oldPassword'>Old Password</label>
              <input
                type='text'
                id='oldPassword'
                name='oldPassword'
                className='input'
                value={oldPassword}
                onChange={this.handleChange}
              />
              <ErrorMessage errorText={this.validationErrors.oldPassword} />
            </div>
            <div className='form-group'>
              <label htmlFor='newPassword'>New Password</label>
              <input
                type='text'
                id='newPassword'
                name='newPassword'
                className='input'
                value={newPassword}
                onChange={this.handleChange}
              />
              <ErrorMessage errorText={this.validationErrors.newPassword} />
              <p className='password-info-message'>{passwordInfoMessage}</p>
            </div>
            <button type='submit' className='button button-primary w-100'>Change Password</button>
          </form>
        </div>
      </ContentWrapper>
    );
  }
}

const mapDispatchToProps = {
  changePasswordAction,
  signIn
};

export default connect(null, mapDispatchToProps)(ChangePassword);



// WEBPACK FOOTER //
// ./src/components/ChangePassword.js